<template>
  <div>
    <v-form>
      <v-container>
        <v-alert v-model="passwordWarning" dense type="info" dismissible>
          Please change your <strong>Password</strong>.
        </v-alert>
        <!-- <v-btn @click="print">Print</v-btn> -->
        <v-row>
          <v-col cols="10" sm="12" md="12" xs="12">
            <v-img
              :src="contentSrc"
              role="img"
              contain
              max-height="550"
            ></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <v-dialog
      v-model="dialog"
      width="700"
      persistent
      v-if="genConfig.sapInfoTypesIntegration"
    >
      <v-card>
        <v-card-title>
          <span>New Hires Employees with no Position ID</span>
        </v-card-title>
        <v-card-text>
          <!-- <v-data-table :items="employees" :headers="headers"></v-data-table> -->
          <custom-table
            :items="employees"
            :headers="headers"
            :loading="loading"
          >
            <!-- <template slot="actions" slot-scope="{item}">
              <slot name="actions" v-bind:item="item"></slot>
            </template> -->
          </custom-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.stop="dialog = !dialog" text>
            Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { isNullOrUndefined } from "../validation/validation";
import { getCookie } from "../helpers/utility";
import CustomTable from "../components/CustomTable";
import { getJwtKeyName } from "../helpers/utility";
// import { jsPDF } from "jspdf";
export default {
  metaInfo: {
    title: "Home",
    titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
  },
  data: () => ({
    content: null,
    employees: [],
    headers: [
      {
        text: "Employee Code",
        value: "empCode",
        sortable: true,
      },
      {
        text: "Name",
        value: "fullName",
        sortable: true,
      },
      {
        text: "Designation",
        value: "designation",
        sortable: true,
      },
      {
        text: "Pay House",
        value: "payHouse",
        sortable: true,
      },
    ],
    dialog: false,
    loading: false,
    passwordWarning: false,
  }),
  components: {
    CustomTable,
  },
  methods: {
    ...mapActions("company", ["getCompanyInfo"]),
    ...mapActions("config", ["getGenConfig"]),
    getEmpInfoNoPosID() {
      this.loading = true;
      this.$axios
        .get(`/api/employmentInfo/no-pos-id`)
        .then(({ data }) => {
          if (data.length > 0) {
            this.employees = data;
            this.dialog = true;
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    leaving() {
      //localStorage.removeItem(getJwtKeyName());
    },
    getPasswordWarning() {
      this.$axios
        .get(`/api/users/password-warning`)
        .then(({ data }) => {
          this.passwordWarning = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    // print() {
    //   let pdf = new jsPDF({ format: "a4" });
    //   pdf.addFont("Calibri Regular.ttf", "Calibri", "normal");
    //   pdf.addFont("Calibri Regular.ttf", "calibri", "normal");
    //   pdf.addFont("Calibri Bold.ttf", "Calibri", "bold");
    //   pdf.addFont("Calibri Bold.ttf", "calibri", "bold");
    //   // pdf.addFont("Calibri Italic.ttf", "Calibri", "italic");
    //   // pdf.addFont("Calibri Bold Italic.ttf", "Calibri", "bold italic");
    //   // pdf.addFont("Calibri Light.ttf", "Calibri", "light");
    //   // pdf.addFont("Calibri Light Italic.ttf", "Calibri", "light italic");
    //   //pdf.setFont("Calibri");
    //   pdf.setFont("Calibri");
    //   console.log(pdf.getFontList());
    //   pdf.line(10, 30, 200, 30);

    //   pdf.setLineWidth(0.5).line(10, 31, 200, 31);
    //   var width = pdf.internal.pageSize.getWidth();
    //   //header
    //   //pdf.setFont("calibri");
    //   pdf
    //     .setFont(undefined, "bold")
    //     .setFontSize(16)
    //     .text("EMPLOYMENT EXIT CLEARANCE FORM", width / 2, 40, {
    //       align: "center",
    //     });
    //   //.setFont("Calibri");

    //   // Table
    //   pdf.setLineWidth(0);
    //   //horizontal
    //   pdf.line(20, 50, 190, 50); // start
    //   pdf.line(20, 120, 190, 120); // end

    //   pdf.line(20, 55, 190, 55);
    //   // vertical
    //   pdf.line(20, 50, 20, 120); // start
    //   pdf.line(190, 50, 190, 120); // end

    //   pdf.setProperties({
    //     title: "Report",
    //   });
    //   window.open(pdf.output("bloburl"));
    // },
    // getAntiforgery() {
    //   this.axios.get(`/api/xsrfToken`)
    // }
    // getContent() {
    //   this.$axios
    //     .get(`${API_ENDPOINT}/content`)
    //     .then(({ data }) => {
    //       this.content = data;
    //     })
    //     .catch(({ response }) => {
    //       this.$toast.error(response.data.message);
    //     });
    // }
  },
  computed: {
    ...mapState("company", ["company"]),
    ...mapState("config", ["genConfig"]),
    contentSrc() {
      if (!isNullOrUndefined(this.company.webLogoContent)) {
        return "data:image/jpeg;base64," + this.company.webLogoContent;
      } else return "";
    },
  },
  created() {
    this.getCompanyInfo();
    this.getGenConfig();
    this.getEmpInfoNoPosID();
    this.getPasswordWarning();
    //this.getAntiforgery();

    window.addEventListener("beforeunload", this.leaving);
  },
};
</script>
